import { MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import S from './EntityLinkStyles';

type Props = {
  /** Detail page path. When missing, the tag stays plain so the row keeps handling the click. */
  to?: string;
  label: string;
  children: JSX.Element;
};

function EntityLink({ to, label, children }: Props): JSX.Element {
  const navigate = useNavigate();

  if (!to) {
    return children;
  }

  const handleClick = (event: MouseEvent<HTMLButtonElement>): void => {
    event.stopPropagation();
    navigate(to);
  };

  return (
    <S.Button type="button" aria-label={label} onClick={handleClick}>
      {children}
    </S.Button>
  );
}

export default EntityLink;
